module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_7016.9d0aaa4e.png";